import { MediaFolderTree } from '@atom/types/media';

import MoveFolderTreeList from './MoveFolderTreeList';

type MoveFolderTreeViewProps = {
  tree: MediaFolderTree;
};

const MoveFolderTreeView = ({ tree }: MoveFolderTreeViewProps) => (
  <MoveFolderTreeList trees={[tree]} level={1} isRoot />
);

export default MoveFolderTreeView;
